"use strict";
/**
 * Copyright 2017-present Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain
 * a copy of the license in the LICENSE and PATENTS files in the root of this
 * repository.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/** Enumeration describing the various kinds of member supported by this plugin. */
var Kind;
(function (Kind) {
    Kind["Class"] = "class";
    Kind["Constructor"] = "constructor";
    Kind["Enum"] = "enum";
    Kind["EnumMember"] = "enum member";
    Kind["Interface"] = "interface";
    Kind["Method"] = "method";
    Kind["Parameter"] = "parameter";
    Kind["Signature"] = "signature";
    Kind["Property"] = "property";
    Kind["TypeAlias"] = "type alias";
})(Kind = exports.Kind || (exports.Kind = {}));
function typeguard(kind) {
    return function (data) { return data != null && data.kind === kind; };
}
// wooooo typeguards
exports.isTsClass = typeguard(Kind.Class);
exports.isTsConstructor = typeguard(Kind.Constructor);
exports.isTsEnum = typeguard(Kind.Enum);
exports.isTsEnumMember = typeguard(Kind.EnumMember);
exports.isTsInterface = typeguard(Kind.Interface);
exports.isTsMethod = typeguard(Kind.Method);
exports.isTsParameter = typeguard(Kind.Parameter);
exports.isTsProperty = typeguard(Kind.Property);
exports.isTsSignature = typeguard(Kind.Signature);
exports.isTsTypeAlias = typeguard(Kind.TypeAlias);



//////////////////
// WEBPACK FOOTER
// ./node_modules/documentalist/dist/client/typescript.js
// module id = 1304
// module chunks = 0